"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ConferenceRoomConnectorOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ConferenceRoomConnectorOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 0c-.652 0-1.201.419-1.408 1H9c-.827 0-1.5.672-1.5 1.5V4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h3.5v1.5c0 .275-.225.5-.5.5H2.908A1.496 1.496 0 0 0 0 14.5a1.496 1.496 0 0 0 2.908.5H7c.827 0 1.5-.673 1.5-1.5V12H12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H8.5V2.5A.5.5 0 0 1 9 2h4.092A1.495 1.495 0 0 0 16 1.5 1.5 1.5 0 0 0 14.5 0ZM2 14.5a.5.5 0 1 1 0-.001v.002ZM6.216 11c.314-.449.883-.855 1.784-.855.902 0 1.47.406 1.785.855H6.216ZM12 5c.551 0 1 .449 1 1v4c0 .551-.449 1-1 1h-1.087C10.545 10.092 9.615 9.145 8 9.145c-1.615 0-2.545.947-2.912 1.855H4c-.551 0-1-.449-1-1V6c0-.551.449-1 1-1h8ZM9.24 7.287a1.238 1.238 0 1 1-2.478 0 1.238 1.238 0 0 1 2.477 0ZM14.5 2a.5.5 0 0 1-.5-.5V1.5a.5.5 0 1 1 .5.501Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ConferenceRoomConnectorOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ConferenceRoomConnectorOutline;
exports["default"] = _default;